import { getProxyUrl } from '@proxies/index'

export default async function fetchLinkedChildrenInfo(idUnidades: number) {
  const _info = await fetch(
    getProxyUrl(`api/acabados/getelementosenlazadosunidadacabados/${idUnidades}`),
    {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Accept-Language': 'ES',
        Authorization: 'Ninpo ' + sessionStorage.getItem('access_token'),
      },
    },
  )
  return _info.json()
}
